export const permissionService = {
  hasPermission: (permission: string, permissions: string[]): boolean => {
    if (permissions.find((p) => p === permission)) return true
    if (!permission.includes('.')) return false
    const permissionSegments = permission.split('.')
    const permissionWithoutLastSegment = permissionSegments.slice(0, permissionSegments.length - 1).join('.')
    return permissionService.hasPermission(permissionWithoutLastSegment, permissions)
  },
}
